/**
 * Complements Swiper + PhotoSwipe: syncs `inert` with hidden slides/holders so
 * focus cannot enter off-screen or aria-hidden content (Siteimprove / WCAG).
 * Safe no-op when `inert` is unsupported.
 */
(function () {
  'use strict';

  if (!('inert' in HTMLElement.prototype)) {
    return;
  }

  function slideShouldBeInert(slide) {
    return (
      !slide.classList.contains('swiper-slide-active') &&
      !slide.classList.contains('swiper-slide-visible')
    );
  }

  function bindProductMediaSwiper(swiperEl) {
    if (swiperEl.dataset.a11yInertBound === 'true') {
      return;
    }
    var swiper = swiperEl.swiper;
    if (!swiper) {
      return;
    }
    swiperEl.dataset.a11yInertBound = 'true';

    if (!swiper.params.watchSlidesProgress) {
      swiper.params.watchSlidesProgress = true;
      swiper.update();
    }

    function sync() {
      swiper.slides.forEach(function (slide) {
        slide.inert = slideShouldBeInert(slide);
      });
    }

    swiper.on('afterInit slideChange transitionEnd observerUpdate resize', sync);
    sync();
  }

  function scanProductSwipers() {
    document.querySelectorAll('[data-product-media-shell] .swiper').forEach(bindProductMediaSwiper);
  }

  function syncPswpItems(root) {
    root.querySelectorAll('.pswp__item').forEach(function (el) {
      el.inert = el.getAttribute('aria-hidden') === 'true';
    });
  }

  function observePswpRoot(pswp) {
    if (!pswp || pswp.dataset.a11yPswpObserved === 'true') {
      return;
    }
    pswp.dataset.a11yPswpObserved = 'true';
    syncPswpItems(pswp);
    var mo = new MutationObserver(function () {
      syncPswpItems(pswp);
    });
    mo.observe(pswp, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function onBodyChildListChange() {
    var pswp = document.querySelector('.pswp');
    if (pswp) {
      observePswpRoot(pswp);
    }
  }

  document.addEventListener('product-form:ready', function () {
    requestAnimationFrame(function () {
      scanProductSwipers();
      setTimeout(scanProductSwipers, 250);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(scanProductSwipers, 0);
    setTimeout(scanProductSwipers, 600);

    if (document.body) {
      var mo = new MutationObserver(onBodyChildListChange);
      mo.observe(document.body, { childList: true });
    }
    onBodyChildListChange();
  });
})();
